import { Injectable, inject } from '@angular/core';

import { FavoriteDataContextInterface } from '@modules/favorites/interfaces/favorite-data-context.interface';
import { TranscriptEntryInterface, TRANSCRIPT_ENTRY_TYPE } from '@modules/media/models/transcript-entry.model';
import { TranscriptStatus } from '@modules/media/models/transcript.model';

import { Adapter } from './adapter';
import { MediaAdapter } from './media.adapter';

interface TextResponse {
  value: string;
  processed: string;
  format: any;
}

export interface TranscriptEntryResponseInterface {
  id: string;
  type: string;
  link: any;
  livestream_media: any[];
  quote: string;
  speaker: any;
  text: TextResponse;
  time: number;
  entry_type: TRANSCRIPT_ENTRY_TYPE;
  chapter?: {
    id: string;
    type: string;
    layout: string;
    title: string;
  };
}

@Injectable({
  providedIn: 'root',
})
export class TranscriptEntryAdapter implements Adapter<TranscriptEntryInterface> {
  private mediaAdapter = inject(MediaAdapter);

  public parse(d: TranscriptEntryResponseInterface, context?: FavoriteDataContextInterface): TranscriptEntryInterface {
    return {
      id: d.id,
      type: d.type,
      text: d.text?.value,
      chapter: d.chapter?.title || '',
      entryType: d.entry_type,
      linkText: d.link?.title || '',
      linkUrl: d.link?.uri || '',
      media: d.livestream_media
        .map((item) => this.mediaAdapter.parse(item, [], context))
        .filter((item) => item !== null),
      quote: d.quote,
      speaker: d.speaker
        ? {
            id: d.speaker.id,
            title: d.speaker.title,
            firstname: d.speaker.first_name,
            lastname: d.speaker.last_name,
          }
        : null,
      status: TranscriptStatus.STARTED,
      test: false, // might be needed
      time: d.time,
    };
  }
}
